import { W47_BASE_ALLOYS, W47_FILLER_ALLOYS, baseGroupForAlloy, fillerForAlloy } from "./w47-aluminum-data";

type Props = {
  baseAlloy: string;
  fillerAlloy: string;
  onBaseAlloyChange?: (alloy: string) => void;
  onFillerAlloyChange?: (alloy: string) => void;
  onBaseChange?: (alloy: string) => void;
  onFillerChange?: (alloy: string) => void;
};

export default function W47AluminumQualificationFields({
  baseAlloy,
  fillerAlloy,
  onBaseAlloyChange,
  onFillerAlloyChange,
  onBaseChange,
  onFillerChange,
}: Props) {
  const baseGroup = baseGroupForAlloy(baseAlloy);
  const filler = fillerForAlloy(fillerAlloy);
  const changeBase = onBaseAlloyChange || onBaseChange || (() => {});
  const changeFiller = onFillerAlloyChange || onFillerChange || (() => {});

  return <>
    <label>Base-metal alloy
      <select value={baseAlloy} onChange={e => changeBase(e.target.value)} required>
        {[1, 2, 3, 4, 5].map(group => <optgroup key={group} label={`W47.2 Base-metal Group ${group}`}>
          {W47_BASE_ALLOYS.filter(x => x.group === group).map(x => <option key={x.alloy} value={x.alloy}>{x.alloy}</option>)}
        </optgroup>)}
      </select>
    </label>
    <label>Base-metal group
      <div className="calculated-field">{baseGroup ? `Group ${baseGroup}` : "Select alloy"}</div>
    </label>
    <label>Filler-metal alloy
      <select value={fillerAlloy} onChange={e => changeFiller(e.target.value)} required>
        {[1, 2, 3].map(group => <optgroup key={group} label={`W47.2 Filler-metal Group ${group}`}>
          {W47_FILLER_ALLOYS.filter(x => x.group === group).map(x => <option key={x.alloy} value={x.alloy}>{x.alloy} · {x.family}</option>)}
        </optgroup>)}
      </select>
    </label>
    <label>Filler qualification
      <div className="calculated-field">{filler ? `${filler.family} · Group ${filler.group}` : "Select filler alloy"}</div>
    </label>
  </>;
}
